import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteData,
  type RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteError,
  type RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteResponse,
  removeRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDelete,
} from '../../generated';

export type RemoveRetailerRegionFromOrganizationMutationVariables =
  RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteData['path'];

export type RemoveRetailerRegionFromOrganizationMutation =
  RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteResponse;

export const useRemoveRetailerRegionFromOrganizationMutation = <
  TError = RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      RemoveRetailerRegionFromOrganizationMutation,
      TError,
      RemoveRetailerRegionFromOrganizationMutationVariables,
      TContext
    >,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<
    RemoveRetailerRegionFromOrganizationMutation,
    TError,
    RemoveRetailerRegionFromOrganizationMutationVariables,
    TContext
  >({
    mutationKey: ['RemoveRetailerRegionFromOrganization'],
    mutationFn: async ({ org_id, retailer_region_id }: RemoveRetailerRegionFromOrganizationMutationVariables) => {
      const { data } =
        await removeRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDelete({
          path: { org_id, retailer_region_id },
          throwOnError: true,
        });
      return data;
    },
    ...options,
  });
};
